<template>
  <validation-observer ref="observer">
    <form @submit.prevent="submit">
      <validation-provider
        v-slot="{ errors }"
        name="shaft"
        rules="required"
        mode="lazy"
      >
        <v-select
          v-model="copyFrom"
          :items="shafts"
          :error-messages="errors"
          :label="
            copyFrom && copyFrom.title === 'Neuer Schacht'
              ? 'Konfiguration *'
              : 'Konfiguration kopieren von *'
          "
          data-vv-name="shaft"
          item-text="title"
          item-value="id"
          return-object
          outlined
          color="grey darken-2"
        >
          <template v-slot:item="{ item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs">
              <v-list-item-content>
                <v-list-item-title>
                  <v-row no-gutters align="center">
                    <span>{{ item.title }}</span>
                    <v-spacer></v-spacer>
                    <span v-if="item.site_id">{{ item.site_id.name }}</span>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
      <v-checkbox
        v-model="copyWithBuildup"
        v-if="isCopyWithBuildupsEnabled"
        label="Schachtaufbau kopieren"
        class="pt-0 mt-0 mb-2"
      >
      </v-checkbox>
      <validation-provider
        v-slot="{ errors }"
        name="site"
        rules="required"
        mode="lazy"
      >
        <v-select
          v-model="shaft.site_id"
          :items="sites"
          :error-messages="errors"
          label="Baustelle *"
          data-vv-name="site"
          item-text="name"
          item-value="id"
          outlined
          color="grey darken-2"
        >
          <template v-slot:append-item>
            <v-divider class="mb-2"></v-divider>
            <v-list-item @click="$emit('addSiteClick')">
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-plus-circle
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Neue Baustelle hinzufügen
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        name="title"
        :rules="`required|shaftTitleUnique:${shaft.site_id}|max:50`"
        mode="lazy"
      >
        <v-text-field
          v-model="shaft.title"
          :error-messages="errors"
          label="Schachtbezeichnung *"
          outlined
          color="grey darken-2"
        >
        </v-text-field>
      </validation-provider>

      <div class="my-4 text-center">
        <v-btn
          color="primary"
          class="text-center"
          type="submit"
          :loading="isSubmitting"
          outlined
        >
          Schacht hinzufügen
        </v-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'FormAddShaft',
  components: {},
  props: ['sites', 'initialSite', 'initialShaft'],
  data: () => ({
    isSubmitting: false,
    addSiteVisible: false,
    shaft: {
      title: '',
      site_id: '',
    },
    copyFrom: { title: 'Neuer Schacht', copyWithBuildup: false },
    copyWithBuildup: false,
  }),
  computed: {
    ...mapGetters([]),
    shafts() {
      if (!this.sites) return [];
      var shafts = [{ title: 'Neuer Schacht', copyWithBuildup: false }];
      this.sites.forEach(site => {
        site.shafts.forEach(shaft => {
          shafts.push(shaft);
        });
      });
      return shafts;
    },
    isCopyWithBuildupsEnabled() {
      if (this.copyFrom && this.copyFrom.title === 'Neuer Schacht')
        return false;
      return true;
    },
  },
  watch: {
    initialSite() {
      this.shaft.site_id = parseInt(this.initialSite);
    },
    initialShaft() {
      this.copyFrom = this.shafts.find(item => item.id == this.initialShaft);
    },
    copyFrom() {
      this.copyWithBuildup = false;
    },
  },
  methods: {
    ...mapActions(['addShaft']),
    submit() {
      this.$refs.observer.validate().then(async success => {
        if (!success) {
          return;
        }
        this.isSubmitting = true;
        try {
          if (this.copyFrom && this.copyFrom.title !== 'Neuer Schacht') {
            this.shaft.copyFrom = this.copyFrom;
            this.shaft.copyWithBuildup = this.copyWithBuildup;
          }
          var result = await this.addShaft(this.shaft);
          if (result) this.$router.push('/schacht/' + result.id);
          this.$emit('submit');
        } catch {
          // ignored
        }
        this.isSubmitting = false;
      });
    },
    clear() {
      this.$refs.observer.reset();
    },
  },
};
</script>
